<template>
  <div v-if="isLoaded">
    <price-base-own-cost-price
      :prices.sync="prices"
      :service.sync="service"
    ></price-base-own-cost-price>
  </div>
</template>

<script>
import Price from '@/services/hatsApi/Price'

export default {
  data () {
    return {
      prices: this.basePrices,
      isLoaded: false
    }
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    basePrices: {
      default: () => ([]),
      type: Array,
      required: false
    }
  },
  async created () {
    if (!this.prices.length) {
      try {
        let filter = [
          {
            property: 'serviceId',
            value: this.$route.params.type_id
          }
        ]
        const basePriceResponse = await Price.getBasePrices(filter)
        this.prices = basePriceResponse.data.data
      } catch (error) {
        console.log(error)
      }
    }
    this.isLoaded = true
  },
  watch: {
    prices (val) {
      this.$emit('update:basePrices', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/base/OwnCostType.vue